/*
 * VPDB - Virtual Pinball Database
 * Copyright (C) 2019 freezy <freezy@vpdb.io>
 *
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; either version 2
 * of the License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 * Modified for sigmashake-pinball by SigmaShake, 2026.
 */

import type { BallFrame } from "../../../shared/contracts";
import { ItemState } from "../../core/item-state";
import { Matrix2D } from "../../math/matrix2d";
import { Vertex3D } from "../../math/vertex3d";

/**
 * The dynamic ball state.
 *
 * This is the data we need to position the ball on the playfield.
 */
export class BallState extends ItemState {
  public pos: Vertex3D;
  public orientation: Matrix2D = new Matrix2D();
  public isFrozen: boolean = false;

  public constructor(name: string, pos: Vertex3D) {
    super();
    this.name = name;
    this.pos = new Vertex3D(pos.x, pos.y, pos.z);
  }

  /** The render values of the ball. Orientation is a row-major 3x3 matrix. */
  public toBallFrame(id: number): BallFrame {
    const m = this.orientation.matrix;
    return {
      id,
      pos: { x: this.pos.x, y: this.pos.y, z: this.pos.z },
      orientation: [
        m[0][0],
        m[0][1],
        m[0][2],
        m[1][0],
        m[1][1],
        m[1][2],
        m[2][0],
        m[2][1],
        m[2][2],
      ],
    };
  }
}
